module.exports = __webpack_public_path__ + "media/images/payment-3-b9d41b0809a7385cf164099cb87043b0.svg";